<button
  mat-icon-button
  [matTooltip]="'Move to a different tab'"
  [intercomTarget]="'toolbar-context-menu-move-to-tab'"
  [matMenuTriggerFor]="tabSelection"
>
  <fa-icon class="fs-08" [icon]="['fal', 'arrow-up']"></fa-icon>
</button>
<mat-menu #tabSelection="matMenu" yPosition="below" xPosition="after">
  <div class="font-semibold fs-09 pl-3 pt-2 pb-1">Move To:</div>
  <button
    mat-menu-item
    *ngFor="let tab of tabs; trackBy: trackByName; let i = index"
    class="font-normal"
    [hidden]="tab.path === activeTab"
    (click)="moveToTab.next(tab.path)"
    [intercomTarget]="'toolbar-context-menu-move-to-tab-button-' + i"
  >
    {{ tab.name }}
  </button>
</mat-menu>
